import { COMMON } from "../../util/localizations"

const TRANSLATIONS = {
    en: {
        ...COMMON.en.eventData,
        ...COMMON.en.organizationData,
        ...COMMON.en.personData,
        ...COMMON.en.placeData,
        ...COMMON.en.shared,
    }
}

export default TRANSLATIONS